const ROOT_KEY = "accounts";

export const accountsKeys = {
  all: () => [ROOT_KEY],
  logo: () => [...accountsKeys.all(), "logo"],
  account: (accountId: number | undefined) => [...accountsKeys.all(), "account", accountId],
  category: (categoryId: number) => [...accountsKeys.all(), "category", categoryId],
  locales: (accountId: number | undefined) => [...accountsKeys.all(), "locales", accountId]
};
